export default {"src":"/_next/static/media/Email.4e63987c.svg","height":16,"width":20,"blurWidth":0,"blurHeight":0};